module.exports = __webpack_public_path__ + "static/media/menu-icon.27c38c00.svg";